import styled from 'styled-components';

import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';
import Grid from '@klv/utils/grid';

export const StyledGrid = styled(Grid)``;

export const StyledSearchHeadline = styled(Typography)`
  grid-column: 1/-1;
  text-align: center;
`;

export const SearchByHeadline = styled(Typography)`
  grid-column: 1/-1;
  margin: 4rem 0;
`;
export const BackgroundColor = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightSand};
`;

export const StyledContainer = styled.div``;

export const FeaturedResources = styled.div``;

export const StyledFeaturedHeadline = styled(Typography)`
  margin-bottom: .8rem;
`;

export const StyledFeaturedSubhead = styled(Typography)`
  margin-bottom: 3.2rem;
`;

export const ResourceCardList = styled(Grid)`
  row-gap: 2.4rem;
  padding: 0;
`;
